import { Skeleton } from '@mui/material';
import css from './VideoTimeline.module.scss';

export const TimelineSkeleton = () => {
  return <Skeleton variant="rectangular" height={120} className={css.timelineSkeletonBlock} />;
};
